import Checkbox from '@mui/material/Checkbox';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText';
import { strippedInputObj } from '../Interfaces/TestCaseInterface';

interface TestListProps {
  tests: Record<string, Array<Array<strippedInputObj>>>,
  toggleToSuite: (test: string) => void,
  deleteFromSuite: (removedTest: string) => void,
  editTestInSuite: (newTestName: string, oldTestName: string) => void,
  testsInSuite: Array<string>,
  editSuite: boolean
}

export const TestList = (props: TestListProps) => {

  return (
    <div>
      <div>
        <h4>Available Tests:</h4>
      </div>
      <List>
        {
          Object.keys(props.tests).length > 0 ?
                Object.keys(props.tests).map((test) => {
                  return (
                  <ListItemButton key={test} disabled={!props.editSuite} onClick={() => props.toggleToSuite(test)}>
                    <ListItem>
                      <ListItemIcon>
                        <Checkbox
                          id={`${test}-checkbox`}
                          value={`${test}`}
                          checked={props.testsInSuite.includes(test)}
                          disabled={!props.editSuite}
                          aria-label={`${test}-checkbox`}
                        />
                      </ListItemIcon>
                      <ListItemText primary={test}/>
                    </ListItem>
                  </ListItemButton>
                  );
                }) :
            <ListItem>No Available Tests</ListItem>}
        
      </List><br />
    </div>
  )
}
